import { convertHEICToImageData } from "./heic-converter"

export const getBitmapSourceFromBlob = async (
	blob: Blob,
	isHEIC: boolean,
): Promise<ImageBitmapSource> => {
	if (!isHEIC) {
		return blob
	}

	const inputBuffer = await blob.arrayBuffer()
	return await convertHEICToImageData(inputBuffer)
}
